
<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <h3 class="box-title">Inbox</h3>

      <div class="box-tools pull-right">
        <div class="has-feedback">
          <input type="text" class="form-control input-sm" placeholder="Search Mail" />
          <span class="glyphicon glyphicon-search form-control-feedback"></span>
        </div>
      </div>
      <!-- /.box-tools -->
    </div>
    <!-- /.box-header -->
    <div class="box-body no-padding">
      <div class="mailbox-controls">
        <!-- Check all button -->
        <button type="button" class="btn btn-default btn-sm checkbox-toggle">
          <i class="fa fa-square-o"></i>
        </button>
        <div class="btn-group">
          <button type="button" class="btn btn-default btn-sm">
            <i class="fa fa-trash-o"></i>
          </button>
          <button type="button" class="btn btn-default btn-sm">
            <i class="fa fa-reply"></i>
          </button>
          <button type="button" class="btn btn-default btn-sm">
            <i class="fa fa-share"></i>
          </button>
        </div>
        <!-- /.btn-group -->
        <button type="button" class="btn btn-default btn-sm">
          <i class="fa fa-refresh"></i>
        </button>
        <div class="pull-right">
          1-50/200
          <div class="btn-group">
            <button type="button" class="btn btn-default btn-sm">
              <i class="fa fa-chevron-left"></i>
            </button>
            <button type="button" class="btn btn-default btn-sm">
              <i class="fa fa-chevron-right"></i>
            </button>
          </div>
          <!-- /.btn-group -->
        </div>
        <!-- /.pull-right -->
      </div>
      <div class="table-responsive mailbox-messages">
        <table class="table table-hover table-striped">
          <tbody>
            <tr>
              <td>
                <div
                  class="icheckbox_flat-blue"
                  aria-checked="false"
                  aria-disabled="false"
                  style="position: relative;"
                >
                  <input type="checkbox" style="position: absolute; opacity: 0;" />
                  <ins
                    class="iCheck-helper"
                    style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"
                  ></ins>
                </div>
              </td>
              <td class="mailbox-star">
                <a>
                  <i class="fa fa-star text-yellow"></i>
                </a>
              </td>
              <td class="mailbox-name">
                <a href="read-mail.html">Alexander Pierce</a>
              </td>
              <td class="mailbox-subject">
                <b>AdminLTE 2.0 Issue</b> - Trying to find a solution to this problem...
              </td>
              <td class="mailbox-attachment"></td>
              <td class="mailbox-date">5 mins ago</td>
            </tr>
            <tr>
              <td>
                <div
                  class="icheckbox_flat-blue"
                  aria-checked="false"
                  aria-disabled="false"
                  style="position: relative;"
                >
                  <input type="checkbox" style="position: absolute; opacity: 0;" />
                  <ins
                    class="iCheck-helper"
                    style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"
                  ></ins>
                </div>
              </td>
              <td class="mailbox-star">
                <a>
                  <i class="fa fa-star-o text-yellow"></i>
                </a>
              </td>
              <td class="mailbox-name">
                <a href="read-mail.html">Alexander Pierce</a>
              </td>
              <td class="mailbox-subject">
                <b>AdminLTE 2.0 Issue</b> - Trying to find a solution to this problem...
              </td>
              <td class="mailbox-attachment">
                <i class="fa fa-paperclip"></i>
              </td>
              <td class="mailbox-date">28 mins ago</td>
            </tr>
            <tr>
              <td>
                <div
                  class="icheckbox_flat-blue"
                  aria-checked="false"
                  aria-disabled="false"
                  style="position: relative;"
                >
                  <input type="checkbox" style="position: absolute; opacity: 0;" />
                  <ins
                    class="iCheck-helper"
                    style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"
                  ></ins>
                </div>
              </td>
              <td class="mailbox-star">
                <a>
                  <i class="fa fa-star-o text-yellow"></i>
                </a>
              </td>
              <td class="mailbox-name">
                <a href="read-mail.html">Alexander Pierce</a>
              </td>
              <td class="mailbox-subject">
                <b>AdminLTE 2.0 Issue</b> - Trying to find a solution to this problem...
              </td>
              <td class="mailbox-attachment">
                <i class="fa fa-paperclip"></i>
              </td>
              <td class="mailbox-date">11 hours ago</td>
            </tr>
            <tr>
              <td>
                <div
                  class="icheckbox_flat-blue"
                  aria-checked="false"
                  aria-disabled="false"
                  style="position: relative;"
                >
                  <input type="checkbox" style="position: absolute; opacity: 0;" />
                  <ins
                    class="iCheck-helper"
                    style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"
                  ></ins>
                </div>
              </td>
              <td class="mailbox-star">
                <a>
                  <i class="fa fa-star text-yellow"></i>
                </a>
              </td>
              <td class="mailbox-name">
                <a href="read-mail.html">Alexander Pierce</a>
              </td>
              <td class="mailbox-subject">
                <b>AdminLTE 2.0 Issue</b> - Trying to find a solution to this problem...
              </td>
              <td class="mailbox-attachment"></td>
              <td class="mailbox-date">15 hours ago</td>
            </tr>
            <tr>
              <td>
                <div
                  class="icheckbox_flat-blue"
                  aria-checked="false"
                  aria-disabled="false"
                  style="position: relative;"
                >
                  <input type="checkbox" style="position: absolute; opacity: 0;" />
                  <ins
                    class="iCheck-helper"
                    style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"
                  ></ins>
                </div>
              </td>
              <td class="mailbox-star">
                <a>
                  <i class="fa fa-star text-yellow"></i>
                </a>
              </td>
              <td class="mailbox-name">
                <a href="read-mail.html">Alexander Pierce</a>
              </td>
              <td class="mailbox-subject">
                <b>AdminLTE 2.0 Issue</b> - Trying to find a solution to this problem...
              </td>
              <td class="mailbox-attachment">
                <i class="fa fa-paperclip"></i>
              </td>
              <td class="mailbox-date">Yesterday</td>
            </tr>
            <tr>
              <td>
                <div
                  class="icheckbox_flat-blue"
                  aria-checked="false"
                  aria-disabled="false"
                  style="position: relative;"
                >
                  <input type="checkbox" style="position: absolute; opacity: 0;" />
                  <ins
                    class="iCheck-helper"
                    style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"
                  ></ins>
                </div>
              </td>
              <td class="mailbox-star">
                <a>
                  <i class="fa fa-star-o text-yellow"></i>
                </a>
              </td>
              <td class="mailbox-name">
                <a href="read-mail.html">Alexander Pierce</a>
              </td>
              <td class="mailbox-subject">
                <b>AdminLTE 2.0 Issue</b> - Trying to find a solution to this problem...
              </td>
              <td class="mailbox-attachment">
                <i class="fa fa-paperclip"></i>
              </td>
              <td class="mailbox-date">2 days ago</td>
            </tr>
            <tr>
              <td>
                <div
                  class="icheckbox_flat-blue"
                  aria-checked="false"
                  aria-disabled="false"
                  style="position: relative;"
                >
                  <input type="checkbox" style="position: absolute; opacity: 0;" />
                  <ins
                    class="iCheck-helper"
                    style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"
                  ></ins>
                </div>
              </td>
              <td class="mailbox-star">
                <a>
                  <i class="fa fa-star-o text-yellow"></i>
                </a>
              </td>
              <td class="mailbox-name">
                <a href="read-mail.html">Alexander Pierce</a>
              </td>
              <td class="mailbox-subject">
                <b>AdminLTE 2.0 Issue</b> - Trying to find a solution to this problem...
              </td>
              <td class="mailbox-attachment">
                <i class="fa fa-paperclip"></i>
              </td>
              <td class="mailbox-date">2 days ago</td>
            </tr>
            <tr>
              <td>
                <div
                  class="icheckbox_flat-blue"
                  aria-checked="false"
                  aria-disabled="false"
                  style="position: relative;"
                >
                  <input type="checkbox" style="position: absolute; opacity: 0;" />
                  <ins
                    class="iCheck-helper"
                    style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"
                  ></ins>
                </div>
              </td>
              <td class="mailbox-star">
                <a>
                  <i class="fa fa-star text-yellow"></i>
                </a>
              </td>
              <td class="mailbox-name">
                <a href="read-mail.html">Alexander Pierce</a>
              </td>
              <td class="mailbox-subject">
                <b>AdminLTE 2.0 Issue</b> - Trying to find a solution to this problem...
              </td>
              <td class="mailbox-attachment"></td>
              <td class="mailbox-date">2 days ago</td>
            </tr>
            <tr>
              <td>
                <div
                  class="icheckbox_flat-blue"
                  aria-checked="false"
                  aria-disabled="false"
                  style="position: relative;"
                >
                  <input type="checkbox" style="position: absolute; opacity: 0;" />
                  <ins
                    class="iCheck-helper"
                    style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"
                  ></ins>
                </div>
              </td>
              <td class="mailbox-star">
                <a>
                  <i class="fa fa-star text-yellow"></i>
                </a>
              </td>
              <td class="mailbox-name">
                <a href="read-mail.html">Alexander Pierce</a>
              </td>
              <td class="mailbox-subject">
                <b>AdminLTE 2.0 Issue</b> - Trying to find a solution to this problem...
              </td>
              <td class="mailbox-attachment"></td>
              <td class="mailbox-date">2 days ago</td>
            </tr>
            <tr>
              <td>
                <div
                  class="icheckbox_flat-blue"
                  aria-checked="false"
                  aria-disabled="false"
                  style="position: relative;"
                >
                  <input type="checkbox" style="position: absolute; opacity: 0;" />
                  <ins
                    class="iCheck-helper"
                    style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"
                  ></ins>
                </div>
              </td>
              <td class="mailbox-star">
                <a>
                  <i class="fa fa-star-o text-yellow"></i>
                </a>
              </td>
              <td class="mailbox-name">
                <a href="read-mail.html">Alexander Pierce</a>
              </td>
              <td class="mailbox-subject">
                <b>AdminLTE 2.0 Issue</b> - Trying to find a solution to this problem...
              </td>
              <td class="mailbox-attachment"></td>
              <td class="mailbox-date">2 days ago</td>
            </tr>
            <tr>
              <td>
                <div
                  class="icheckbox_flat-blue"
                  aria-checked="false"
                  aria-disabled="false"
                  style="position: relative;"
                >
                  <input type="checkbox" style="position: absolute; opacity: 0;" />
                  <ins
                    class="iCheck-helper"
                    style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"
                  ></ins>
                </div>
              </td>
              <td class="mailbox-star">
                <a>
                  <i class="fa fa-star-o text-yellow"></i>
                </a>
              </td>
              <td class="mailbox-name">
                <a href="read-mail.html">Alexander Pierce</a>
              </td>
              <td class="mailbox-subject">
                <b>AdminLTE 2.0 Issue</b> - Trying to find a solution to this problem...
              </td>
              <td class="mailbox-attachment">
                <i class="fa fa-paperclip"></i>
              </td>
              <td class="mailbox-date">4 days ago</td>
            </tr>
            <tr>
              <td>
                <div
                  class="icheckbox_flat-blue"
                  aria-checked="false"
                  aria-disabled="false"
                  style="position: relative;"
                >
                  <input type="checkbox" style="position: absolute; opacity: 0;" />
                  <ins
                    class="iCheck-helper"
                    style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"
                  ></ins>
                </div>
              </td>
              <td class="mailbox-star">
                <a>
                  <i class="fa fa-star text-yellow"></i>
                </a>
              </td>
              <td class="mailbox-name">
                <a href="read-mail.html">Alexander Pierce</a>
              </td>
              <td class="mailbox-subject">
                <b>AdminLTE 2.0 Issue</b> - Trying to find a solution to this problem...
              </td>
              <td class="mailbox-attachment"></td>
              <td class="mailbox-date">12 days ago</td>
            </tr>
            <tr>
              <td>
                <div
                  class="icheckbox_flat-blue"
                  aria-checked="false"
                  aria-disabled="false"
                  style="position: relative;"
                >
                  <input type="checkbox" style="position: absolute; opacity: 0;" />
                  <ins
                    class="iCheck-helper"
                    style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"
                  ></ins>
                </div>
              </td>
              <td class="mailbox-star">
                <a>
                  <i class="fa fa-star-o text-yellow"></i>
                </a>
              </td>
              <td class="mailbox-name">
                <a href="read-mail.html">Alexander Pierce</a>
              </td>
              <td class="mailbox-subject">
                <b>AdminLTE 2.0 Issue</b> - Trying to find a solution to this problem...
              </td>
              <td class="mailbox-attachment">
                <i class="fa fa-paperclip"></i>
              </td>
              <td class="mailbox-date">12 days ago</td>
            </tr>
            <tr>
              <td>
                <div
                  class="icheckbox_flat-blue"
                  aria-checked="false"
                  aria-disabled="false"
                  style="position: relative;"
                >
                  <input type="checkbox" style="position: absolute; opacity: 0;" />
                  <ins
                    class="iCheck-helper"
                    style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"
                  ></ins>
                </div>
              </td>
              <td class="mailbox-star">
                <a>
                  <i class="fa fa-star text-yellow"></i>
                </a>
              </td>
              <td class="mailbox-name">
                <a href="read-mail.html">Alexander Pierce</a>
              </td>
              <td class="mailbox-subject">
                <b>AdminLTE 2.0 Issue</b> - Trying to find a solution to this problem...
              </td>
              <td class="mailbox-attachment">
                <i class="fa fa-paperclip"></i>
              </td>
              <td class="mailbox-date">14 days ago</td>
            </tr>
            <tr>
              <td>
                <div
                  class="icheckbox_flat-blue"
                  aria-checked="false"
                  aria-disabled="false"
                  style="position: relative;"
                >
                  <input type="checkbox" style="position: absolute; opacity: 0;" />
                  <ins
                    class="iCheck-helper"
                    style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"
                  ></ins>
                </div>
              </td>
              <td class="mailbox-star">
                <a>
                  <i class="fa fa-star text-yellow"></i>
                </a>
              </td>
              <td class="mailbox-name">
                <a href="read-mail.html">Alexander Pierce</a>
              </td>
              <td class="mailbox-subject">
                <b>AdminLTE 2.0 Issue</b> - Trying to find a solution to this problem...
              </td>
              <td class="mailbox-attachment">
                <i class="fa fa-paperclip"></i>
              </td>
              <td class="mailbox-date">15 days ago</td>
            </tr>
          </tbody>
        </table>
        <!-- /.table -->
      </div>
      <!-- /.mail-box-messages -->
    </div>
    <!-- /.box-body -->
    <div class="box-footer no-padding">
      <div class="mailbox-controls">
        <!-- Check all button -->
        <button type="button" class="btn btn-default btn-sm checkbox-toggle">
          <i class="fa fa-square-o"></i>
        </button>
        <div class="btn-group">
          <button type="button" class="btn btn-default btn-sm">
            <i class="fa fa-trash-o"></i>
          </button>
          <button type="button" class="btn btn-default btn-sm">
            <i class="fa fa-reply"></i>
          </button>
          <button type="button" class="btn btn-default btn-sm">
            <i class="fa fa-share"></i>
          </button>
        </div>
        <!-- /.btn-group -->
        <button type="button" class="btn btn-default btn-sm">
          <i class="fa fa-refresh"></i>
        </button>
        <div class="pull-right">
          1-50/200
          <div class="btn-group">
            <button type="button" class="btn btn-default btn-sm">
              <i class="fa fa-chevron-left"></i>
            </button>
            <button type="button" class="btn btn-default btn-sm">
              <i class="fa fa-chevron-right"></i>
            </button>
          </div>
          <!-- /.btn-group -->
        </div>
        <!-- /.pull-right -->
      </div>
    </div>
  </div>
  <!-- /. box -->
</template>
<script>
import { mapGetters, mapActions } from "vuex";

// import i18n from "../../lang";
// import utils from '@/lib/utils';

export default {
  name: "Mailbox",
  data() {
    return {
      email_info: {
        to: "",
        subject: "",
        content: null
      },

      config: {
        // Get options from
        // https://alex-d.github.io/Trumbowyg/documentation
      }
    };
  },
  watch: {},
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW"
    ])
  },

  methods: {
    sendMail() {
      let data = {
        to: this.email_info.to,
        subject: this.email_info.subject,
        content: this.email_info.content
      };

      this.SEND_MAIL(data)
        .then(
          function() {
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ON_SHOW_TOAST({
              message: error,
              styleType: "danger"
            });
          }.bind(this)
        );
    },

    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "SEND_MAIL",
      "ON_SHOW_TOAST"
    ])
  },
  mounted() {},

  components: {}
};
</script>



// WEBPACK FOOTER //
// src/views/Mailbox/Mailbox.vue